export { default } from '~/App';